import React from "react";
import { Navigate, Route } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute: any = (component: any) => {
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated
  );
  return isAuthenticated ? component.children : <Navigate to="/" />;
};

export default PrivateRoute;